import React, {useState} from 'react';
import models from "../../network/models/quick_models";
import payments from '../../network/services/payment';
import {getUserPhoneNumber} from "../../helpers/authenticator";
import customer from "../../network/services/customer";
import {useForm} from "react-hook-form";
import BarLoader from "../BarLoader";
import toastifyHelper from "../../helpers/toastify_helper";

const DropOffClientDetailsForm = ({change}) => {

  const [showLoadingBar, setShowLoadingBar] = useState(false);
  const {register, handleSubmit, watch, errors} = useForm();


  const submitForm = (data) => {

    let requestData = {...models.createDeliveryOrderResponse, ...change.current.deliveryOrder};
    requestData.drop_off.phone_number = data.recipient_phone;
    requestData.manifests = [{
      name: data.item,
      quantity: 1,
      size: "normal"
    }];
    customer.createDeliveryOrder(requestData, getUserPhoneNumber()).then(response => {
      console.log(response.data);
      setShowLoadingBar(true);
      toastifyHelper.toastify.infoToastify("Redirecting to Payment Checkout ...");
      initializePayment(response.data);
    }).catch(error => {
      toastifyHelper.toastify.infoToastify(error.response.data.message);
    })
  };


  const initializePayment = (response) => {
    let data = {...models.createDeliveryOrderResponse, ...response.data};

    let paymentData = models.paymentRequest;
    // Convert amount to pesewas | 100 pesewas == 1 GHS
    paymentData.amount = (data.quote.fee * 100);
    paymentData.email = "no-email@gozing.co";
    paymentData.reference = data.delivery_id;

    payments.payment(paymentData).then(response => {
      let res = {...models.paymentResponse, ...response.data};
      window.location.href = res.data.authorization_url;
    }).catch(error => {
      toastifyHelper.toastify.errorToastify(error.response.data);
    });
  };


  return (
    <>
      {
        showLoadingBar ? <BarLoader/> : null
      }
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={handleSubmit(submitForm)}>
              <ul className="list-unstyled">
                <li style={{marginTop: 15}}>
                  <div className="input-group">
                    <input type="text"
                           className="form-control form-control-lg input-form-alt"
                           placeholder="Recipient's mobile number *"
                           name={"recipient_phone"}
                           ref={register({required: true})}
                           aria-label="Username" aria-describedby="basic-addon1"/>
                  </div>
                </li>
                <li>
                  {errors.recipient_phone &&
                  <small className="small-text-red"> <i
                    className="fas fa-exclamation-triangle"></i> This field is
                    required</small>}
                </li>
                <li>
                  <a className="action-link">Add special notes</a>
                </li>
                <li style={{marginTop: 25}}>
                  <div className="form-row">
                    <div className="col-10">
                      <div className="input-group">
                        <input type="text"
                               name={"item"}
                               className="form-control form-control-lg input-form-alt"
                               placeholder="Item name"
                               ref={register({required: true})}
                               aria-label="Username" aria-describedby="basic-addon1"/>
                      </div>
                    </div>
                    <div className="col">
                      <div className="input-group">
                        <input type="text"
                               className="form-control form-control-lg input-form-alt"
                               placeholder="1"/>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  {errors.item &&
                  <small className="small-text-red"> <i
                    className="fas fa-exclamation-triangle"></i> This field is
                    required</small>}
                </li>
                <li>
                  <a className="action-link">Add another item</a>
                </li>
                <li className="text-right">
                  <button className="btn btn-primary btn-md" disabled={showLoadingBar}>
                    Pay
                  </button>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};


export default DropOffClientDetailsForm;
